export class StatusService {
  constructor() {
    this.dataStatuses = [
      { text: "Active", status: "ACTIVE" },
      { text: "Deactive", status: "DEACTIVE" },
      { text: "Non", status: "Non" },
      { text: "New", status: "NEW" },
    ];
    this.roleDataStatuses = [
      { text: "Active", status: "Active" },
      { text: "Inactive", status: "Inactive" },
    ];
  }
  search(value) {
    return this.dataStatuses.filter((elem) => elem.text.indexOf(value) !== -1);
  }
  async get() {
    return Promise.resolve({ data: { records: this.dataStatuses } });
  }
  async getRole() {
    return Promise.resolve({ data: { records: this.roleDataStatuses } });
  }
}
